import { GuardedComponent } from '../components/guarded-component';
import EditWorkOrder from '../features/workorders/edit-workorder/edit-work-order.page';
import WorkOrderEmployee from '../features/workorders/work-order-employee-grid/work-order-employee';
import { WorkOrdersPage } from '../features/workorders/workorders.page';
import { UserPermissionName } from '../models/user-permission-name';

export const WorkOrdersRoute = {
  // path: '/workorders',
  // element: (
  //   <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_WORKORDER]} showPermissionError>
  //     <WorkOrdersPage />
  //   </GuardedComponent>
  // ),

  path: '/workorders',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_WORKORDER]} showPermissionError>
          <WorkOrdersPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'edit/:id',
      name: 'Edit Workorder',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_WORKORDER]} showPermissionError>
          <EditWorkOrder />
        </GuardedComponent>
      ),
    },
  ],
};
